import { ViewAttestationButton } from "./ViewAttestationButton";
import { useState } from "react";
import useColorAndBackground from "../../../../hooks/attestations/useColorAndBackground";
import { MintDonationButton } from "./MintDonationButton";
import { MintDonationImpactAction } from "./MintDonationImpactAction";
import { ViewAttestationModal } from "../ViewAttestationModal/ViewAttestationModal";
import { generateTransactionUrl } from "../../../attestations/utils/generateTransactionUrl";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function MintingActionButton(_ref) {
  var _attestation$attestat;
  let {
    transaction,
    contributions,
    attestationData
  } = _ref;
  const [isOpen, setIsOpen] = useState({
    mintingModal: false,
    viewAttestationModal: false
  });
  const [isActionStarted, setIsActionStarted] = useState(false);
  function toggleModal(modal) {
    setIsOpen({
      ...isOpen,
      [modal]: !isOpen[modal]
    });
  }
  function toggleMintingModal() {
    toggleModal("mintingModal");
  }
  function toggleViewAttestationModal() {
    toggleModal("viewAttestationModal");
  }
  function HandleActionState(started) {
    setIsActionStarted(started);
  }
  const {
    attestation,
    isFetchingAttestations = false
  } = attestationData;
  const impactImageCid = attestation === null || attestation === void 0 || (_attestation$attestat = attestation.attestation) === null || _attestation$attestat === void 0 || (_attestation$attestat = _attestation$attestat.metadata) === null || _attestation$attestat === void 0 || (_attestation$attestat = _attestation$attestat[0]) === null || _attestation$attestat === void 0 ? void 0 : _attestation$attestat.impactImageCid;
  const isMinted = !!attestation;
  const {
    selectedColor,
    previewBackground,
    selectBackground,
    selectedBackground
  } = useColorAndBackground();
  const {
    attestationChainId: chainId,
    attestationUid = ""
  } = attestation !== null && attestation !== void 0 ? attestation : {};
  const attestationLink = `${process.env.REACT_APP_ATTESTATION_SERVER}/attestation/${attestationUid}`;
  return isMinted ? /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ViewAttestationModal, {
      isOpen: isOpen.viewAttestationModal,
      onClose: toggleViewAttestationModal,
      impactImageCid: impactImageCid,
      transactionUrl: generateTransactionUrl({
        attestationUid,
        chainId: Number(chainId)
      }),
      attestationLink: attestationLink
    }), /*#__PURE__*/_jsx(ViewAttestationButton, {
      onClick: toggleViewAttestationModal
    })]
  }) : /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MintDonationImpactAction, {
      startAction: isActionStarted,
      toggleStartAction: HandleActionState,
      isOpen: isOpen.mintingModal,
      toggleModal: toggleMintingModal,
      contributions: contributions,
      transactionHash: transaction.hash,
      selectedColor: selectedColor,
      previewBackground: previewBackground,
      selectBackground: selectBackground,
      selectedBackground: selectedBackground
    }), /*#__PURE__*/_jsx(MintDonationButton, {
      disabled: isFetchingAttestations,
      onClick: toggleMintingModal
    })]
  });
}